import React, { useCallback } from 'react'
import Sidebar from 'components/App/DesktopView/Layout/Sidebar'

import SearchRawCount from '../SearchRawCount'

export default function Folder({
  itemId,
  name,
  className,
  queryId,
  current,
  onClick,
  shouldDisplayCount,
  linkTo,
  padded,
}) {
  const handleClick = useCallback(
    () => {
      if (onClick) onClick(itemId)
    },
    [onClick, itemId]
  )

  return (
    <Sidebar.Item
      key={itemId}
      to={linkTo}
      onClick={handleClick}
      active={current}
      padded={padded}
      className={className}
      count={shouldDisplayCount && <SearchRawCount queryId={queryId} />}
    >
      {name}
    </Sidebar.Item>
  )
}
